import { BigNews } from "styles/jss/News.styles";
import { ShortDescription } from "styles/jss/Layout.styles";
import HeadTitle from "./HeadTitle";
import NextImage from "../../NextImage";
import DateStamp from "../../DateStamp";
import { getImageUrl, truncateString } from "utils/helperFunction";

export default function BigNewsSection(news) {
  const {
    id,
    attributes: { slug, title, thumbnail, short_description, datetime },
  } = news;

  return (
    <BigNews>
      <div className={"imageWrapper"}>
        <NextImage
          layout={"fill"}
          objectFit={"cover"}
          src={
            getImageUrl(thumbnail.data?.attributes.formats, ["large", "medium"])
              ?.url
          }
          alt={title}
          placeholder="blur"
        />
      </div>
      <div className="contentWrapper">
        <HeadTitle as={"h1"} url={`/media-center/news/${id}/${slug}`}>
          {truncateString(title, 250)}
        </HeadTitle>
        <ShortDescription className="text">
          {truncateString(short_description, 450)}
        </ShortDescription>
        <DateStamp date={datetime} time />
      </div>
    </BigNews>
  );
}
